import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { filteredStationsIdsSelector } from 'Features/Filters/Stations';
import { useLazyGetLastDataValuesQuery } from 'Services/api/reportsApi';
import { Request } from 'Features/StationsNew/Datasources/Datasource/Monitors/types';
import { useSelectedMapFilter } from './useSelectedMapFilter';
import { mapCommonMeteocodes } from './utilts';
import { setMapMeteocodeData } from './mapSlice';

export default function MapViewCommonMeteocodesLoader() {
  const dispatch = useDispatch();
  const { selectedMapFilter } = useSelectedMapFilter();
  const filteredStationsIds = useSelector(filteredStationsIdsSelector);

  const [trigger] = useLazyGetLastDataValuesQuery();

  const request = React.useCallback(async () => {
    const requestItems: Request['requestItems'] = [];
    mapCommonMeteocodes.forEach((meteocode) => {
      filteredStationsIds.forEach((stationId) => {
        requestItems.push({
          meteoCode: meteocode,
          sourceId: stationId,
          sourceType: 'STATION',
          stationEntityId: -1,
          place: '',
          point: -1,
          time: null,
          measures: [{ interval: 10, timeShift: 0, mandatory: false }],
        });
      });
    });
    const params = {
      calc: true,
      round: true,
      requestItems,
    };
    const result = await trigger(params).unwrap();
    dispatch(setMapMeteocodeData(result));
  }, [dispatch, filteredStationsIds, trigger]);

  React.useEffect(() => {
    if (selectedMapFilter === 'COMMON_METEOCODES') {
      request();
    }
  }, [request, selectedMapFilter]);

  return null;
}
